module.exports = __webpack_public_path__ + "img/260e.a404452.svg";